import valueEqual from 'value-equal';



const formats = {
  cvv: {
    segments: [4],
    separator: ''
  },

  giftCard: {
    allowAlpha: true,
    segments: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
    separator: ' '
  },

  monthAndDate: {
    segments: [2, 2],
    separator: '/'
  },

  monthDateAndYear: {
    segments: [2, 2, 4],
    separator: '/'
  },

  phone: {
    template: '(XXX) XXX-XXXX'
  },

  postalCode: {
    allowAlpha: true,
    autoCapitalize: true
    /* segments and separator get set depending on the first character entered */
  }
};



function mask(element, type) {
  const { value } = element;
  const { oldValue } = element.dataset;
  let strippedValue = element.value.replace(/[^0-9]/g, '');
  let strippedOldValue = oldValue.replace(/[^0-9]/g, '');
  let maskedValue = '';
  let position = 0;
  let format;


  if (typeof type === 'string') {
    format = formats[type];
  }

  else {
    format = type;
  }

  if (format.allowAlpha) {
    strippedValue = element.value.replace(/[^0-9A-Za-z]/g, '');
    strippedOldValue = oldValue.replace(/[^0-9A-Za-z]/g, '');
  }

  if (type === 'postalCode') {
    /* value starts with letter */
    if (/^[a-z]/i.test(strippedValue)) {
      /* Canadian Postal Code Format */
      format.allowAlpha = true;
      format.segments = [3, 3];
      format.separator = ' ';
    }
    else if (
      /^[0-9]/.test(strippedValue) /* value starts with number */
      && /[^a-z]/ig.test(strippedValue) /* and has no letters */
    ) {
      /* US ZIP Code Format */
      format.allowAlpha = false;
      format.segments = [5];
      format.separator = '';
    }
    /* there is no value */
    else {
      format.allowAlpha = true;
    }
  }

  const isDeleting = strippedValue < strippedOldValue || (strippedValue === strippedOldValue && /[^0-9A-Za-z]/.test(oldValue[oldValue.length - 1]));

  if (isDeleting || !element.value) {
    updateValue(element, element.value);
    return;
  }

  // Prepend a "0" to the front of certain inputs (turns 3/12 in to 03/12 automatically):

  if (type === 'monthAndDate' || type === 'monthDateAndYear') {
    if (/^[0-9]\//.test(value) || (strippedValue && strippedValue[0] !== '1' && strippedValue[0] !== '0')) {
      strippedValue = `0${strippedValue}`;
    }
  }

  // Strip country codes out of phone numbers:

  if (type === 'phone' && strippedValue.length > 10 && strippedValue[0] === '1') {
    strippedValue = strippedValue.substr(-10);
  }

  if (format.template) {
    const strippedValues = [...strippedValue];

    [...format.template].every((template) => {
      if (template === 'X') {
        const character = strippedValues.shift();

        if (character) {
          maskedValue += character;
          return true;
        }

        return false;
      }

      maskedValue += template;
      return true;
    });
  }

  else {
    format.segments.forEach((segment, i) => {
      let characters = strippedValue.substr(position, segment);
      const isLastSegment = (i + 1) === format.segments.length;

      if (characters.length === segment && !isLastSegment) {
        characters += format.separator;
      }

      maskedValue += characters;
      position += segment;
    });
  }

  if (format.autoCapitalize) {
    maskedValue = maskedValue.toUpperCase();
  }

  updateValue(element, maskedValue);
}



function updateValue(element, maskedValue) {
  let caretPosition = document.activeElement.selectionEnd;
  const caretIsAtEnd = element.value.length === caretPosition;
  const inputEvent = new Event('input', {
    bubbles: true
  });

  element.value = maskedValue;
  element.dataset.oldValue = maskedValue;

  // if cursor was at end when user changed input, push it to end, else keep it where it was:

  if (document.activeElement === element) {
    if (caretIsAtEnd) {
      caretPosition = element.value.length;
    }

    element.setSelectionRange(caretPosition, caretPosition);
  }

  element.dispatchEvent(inputEvent);
}



const maskInput = {
  updated(element, binding) {
    element.dataset.oldValue = element.dataset.oldValue || '';
    const valueChanged = element.dataset.oldValue !== element.value;
    const type = binding.value;
    const typeChanged = !valueEqual(type, binding.oldValue);

    if ((valueChanged || typeChanged) && type) {
      mask(element, type);
    }
  }
};



export default maskInput;
